import { render, staticRenderFns } from "./PFSettlementDocumentsFront.vue?vue&type=template&id=03f5c108"
import script from "./PFSettlementDocumentsFront.vue?vue&type=script&lang=js"
export * from "./PFSettlementDocumentsFront.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports